import React from 'react';
import { remittanceDialogSteps } from './Utils';
import DatePicker from './DatePicker';
import UploadFileSubmit from './UploadFileSubmit';

export default function DialogChildren({
  step,
  startDate,
  date,
  setDate,
  message,
  setMessage,
  ids,
  setIds,
}: {
  step: remittanceDialogSteps;
  startDate: any;
  date: any;
  setDate: any;
  message: String;
  setMessage: any;
  ids: any;
  setIds: any;
}) {
  return (
    <>
      {step === remittanceDialogSteps.pickDate && (
        <DatePicker startDate={startDate} setDate={setDate} date={date} />
      )}
      {step === remittanceDialogSteps.uploadFileSubmit && (
        <UploadFileSubmit
          message={message}
          setMessage={setMessage}
          ids={ids}
          setIds={setIds}
        />
      )}
    </>
  );
}
